<template>
  <div class="conversation">
    <page-header v-if="!isHideHeader" />
    <div v-for="(option, i) in NoticeMessage.noticeInfo" :key="i">
      <marqueue v-if="option.noticeType == 0" :is-h5="true" />
    </div>
    <chat-message-box />
    <reconnect-model v-if="showReconnectModel" />
    <page-footer v-if="showPageFooter" />
    <second-page v-if="dialogVisible" />
    <qeuquetimgout v-if="dialogtime" />
    <channel-time-out v-if="channeltime" />
    <order-list
      :direction="direction"
      @dialogHide="dialogHide"
      @checkOrder="checkOrder"
      ref="orderList"
      v-if="listStatus"
    />
  </div>
</template>

<script>
// import { getParams } from "../../utils";
import { isApp, backPage } from "../../utils/bridge";
import pageHeader from "../components/page-header";
import pageFooter from "../components/page-footer";
import reconnectModel from "../components/reconnect-model";
import chatMessageBox from "../components/chat-message-box";
import secondPage from "../../../../components/second-channel";
import qeuquetimgout from "../../../../components/equeuetimeout";
import utils from "../../utils";
import marqueue from "../../components/marqueue";
import orderList from "src/app/customer/components/orderList";
import channelTimeOut from "src/components/channeltimeout";
import store from "src/app/customer/store";
export default {
  name: "conversation",
  components: {
    pageHeader,
    pageFooter,
    reconnectModel,
    chatMessageBox,
    secondPage,
    qeuquetimgout,
    channelTimeOut,
    orderList,
    marqueue
  },
  data() {
    return {
      time: null,
      direction: "btt"
    };
  },
  computed: {
    ...mapState({
      alreadyLogin: state => state.alreadyLogin,
      isShowEvaluatePage: state => state.isShowEvaluatePage,
      isConversation: state => state.isConversation, //控制底部输入框是否显示
      isQueue: state => state.isQueue,
      rechargeCode: state => state.rechargeCode,
      invalidFlag: state => state.invalidFlag,
      dialogVisible: state => state.dialogVisible,
      showNewChannelDialog: state => state.showNewChannelDialog,
      dialogtime: state => state.dialogtime,
      channeltime: state => state.channeltime,
      isclickimg: state => state.isclickimg,
      listStatus: state => state.listStatus,
      activeName: state => state.activeName,
      isShowNotice: state => state.isShowNotice,
      NoticeMessage: state => state.NoticeMessage,
      enterScene: state => state.enterScene,
      hideHeader: state => state.hideHeader
      // currCustomer:state=>state.currCustomer
    }),
    showReconnectModel() {
      return this.isShowEvaluatePage; //控制重连弹窗显示
    },
    showPageFooter() {
      //显示底部输入框的条件

      return this.isConversation;
    },
    isHideHeader() {
      return this.hideHeader === "true" || this.hideHeader === true;
    }
  },
  created() {
    if (window.location.href.match(/localhost/)) {
      return;
    }
    utils.forbidMoveLeft();
    //
  },

  mounted() {
    const messageBox = document.querySelector("#messageBox");
    window.messageBox = messageBox;
    clearTimeout(this.time);
    this.time = setTimeout(() => {
      messageBox.scrollTop = messageBox.scrollHeight + 350;
      messageBox.scrollIntoView(messageBox.scrollHeight);
      scrollBy(0, messageBox.scrollHeight);
      document.body.scrollTop = messageBox.scrollHeight;

      if (this.showNewChannelDialog === false) {
        if (document.querySelector(".input-area")) {
          clearTimeout(this.time);
          this.time = setTimeout(() => {
            document.querySelector(".input-area").style.paddingBottom =
              0 + "px";
            document.body.scrollTop = document.body.scrollHeight;
          }, 300);
        }
        utils.reEnter();
      }
    }, 500);
    // 息屏后的 UI 修正；历史校正事件由全局 manager 统一处理。
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    if (store.state.isQueue) {
      utils.reEnter();
    }
    store.commit("setState", { isreenter: 1 });
    if (window.history && window.history.pushState) {
      console.log("监听返回 h5 1");

      history.pushState(null, null, "#1");

      //仅仅调用pushState方法或replaceState方法 ，并不会触发该事件，只有用户点击浏览器倒退按钮和前进按钮，
      // 或者使用JavaScript调用back、forward、go方法时才会触发。
      // 另外，该事件只针对同一个文档，如果浏览历史的切换，导致加载不同的文档，该事件也不会触发。
      window.addEventListener("popstate", this.backChange, false);
    }
  },
  methods: {
    handleVisibilityChange() {
      if (document.hidden) {
        console.log("息屏");
      } else {
        console.log("解锁");
        if (this.isclickimg) {
          clearTimeout(this.time);
          this.time = setTimeout(() => {
            this.$store.commit("setState", {
              isclickimg: false
            });
          }, 2000);
        }
        if (!this.isclickimg) {
          if (document.querySelector(".input-area")) {
            clearTimeout(this.time);
            this.time = setTimeout(() => {
              document.querySelector(".input-area").style.paddingBottom =
                0 + "px";
              document.body.scrollTop = document.body.scrollHeight;
            }, 300);
          }
          // Session validation stays here. For the same active session the
          // global manager corrects history without resetting scroll/cursors.
          utils.reEnter({ refreshActiveHistory: false });
          return false;
        }
      }
    },
    backChange() {
      console.log("返回", 1);
      if (!isApp()) {
        history.pushState(null, null, "#1");
      } else {
        backPage();
      }
    },
    dialogHide() {
      this.$store.commit("setState", { listStatus: false });
    },
    checkOrder(item) {
      this.$store.commit("setState", { listStatus: false });
      utils.sendOrder(item);
      this.isShow = false;
    }
  },
  beforeDestroy() {
    clearInterval(this.$store.state.queueTimer);
    clearTimeout(this.time);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("popstate", this.backChange, false);
  }
};
</script>

<style lang="less" scoped>
/*img {*/
/*  -webkit-touch-callout: none;*/
/*  -webkit-user-select: none;*/
/*  -khtml-user-select: none;*/
/*  -moz-user-select: none;*/
/*  -ms-user-select: none;*/
/*  user-select: none;*/
/*}*/
.conversation {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 0;
  .entering {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #787878;
    height: 25px;
    line-height: 25px;
    padding: 0 5px 0 10px;
    width: 110px;
    position: absolute;
    bottom: 52px;
    z-index: 999;
    background: #ffffff;
    left: 5px;
    border-radius: 3px;
    position: fixed;
  }
}
</style>
